import React from "react";
import PropTypes from "prop-types";
import Switch from "rc-switch";

import { CSCContext } from "../CSCContext";

class SwitchInput extends React.Component {
	static contextType = CSCContext;

	componentDidMount() {
		this.updateValue(this.context.getUserData(this.props.name) || this.props.checked);
	}

	updateValue(newValue) {
		this.checked = newValue;
		this.context.setUserData(this.props.name, newValue);
	}

	render() {
		return (
			<div id={this.props.name} className="switch-input">
				<label>{this.props.label + ' '}
					<Switch
						defaultChecked={this.context.getUserData(this.props.name)}
						checkedChildren={this.props.onLabel}
						unCheckedChildren={this.props.offLabel}
						onChange={(checked) => {
							this.updateValue(checked);
						}}
					/>
				</label>
			</div>
		);
	}
}

SwitchInput.propTypes = {
	name: PropTypes.string.isRequired,
	checked: PropTypes.bool,
	label: PropTypes.string,
	onLabel: PropTypes.string,
	offLabel: PropTypes.string,
};

SwitchInput.defaultProps = {
	checked: false,
	label: "",
	onLabel: "On",
	offLabel: "Off",
};

export default SwitchInput;
